import { defineComponent, FieldViewModel, isUndefined } from "../omnia";

export class AllocSMNCtrl {


    static create(): ng.IDirective {

        var def = defineComponent(AllocSMNCtrl, "app/soil/alloc/allocSMN.html", {
            "ngModel": "=",
            "cropping": "="
        });

        def.require = "ngModel";

        return def;

    };

    private cropping: FieldViewModel;

    private editable: boolean;
    private initialValue: number;

    static $inject = ["$scope"];

    constructor(private $scope: ng.IScope) {
    }

    startEdit() {
        if (isUndefined(this.initialValue)) {
            this.initialValue = this["ngModel"];
        }
        this.editable = true;
    }

    cancelEdit() {
        this["ngModel"] = this.initialValue;
        this.editable = false;
    }

}

